import { render, staticRenderFns } from "./OrdersForecastsNotes.vue?vue&type=template&id=7b08eaa2&"
import script from "./OrdersForecastsNotes.vue?vue&type=script&lang=js&"
export * from "./OrdersForecastsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports